export default class OverviewController {
    constructor(elm, args) {
        var catLabel = elm.querySelector('[data-category-label]');
        var topLabel = elm.querySelector('[data-topic-label]');
        let container = elm.querySelector('[data-container]');
        var loadMoreButton = elm.querySelector('[data-load-more]');

        const categoryItemList = elm.querySelectorAll('[data-category-id]')
        categoryItemList.forEach(x => x.onclick = (event) => {
            event.preventDefault();
            setFilter("category", x.innerHTML, x.dataset.categoryId);
        });

        const topicItemList = elm.querySelectorAll('[data-topic-id]')
        topicItemList.forEach(x => x.onclick = (event) => {
            event.preventDefault();
            setFilter("topic", x.innerHTML, x.dataset.topicId);
        });

        loadMoreButton.onclick = (event) => {
            event.preventDefault();
            loadMore(parseInt(elm.dataset.page) + 1);
        }
        
        var dropdownHeadingButtons = elm.querySelectorAll('.dropdown');
        window.addEventListener('click', x => {
            var dropdownButton = x.target.closest('.dropdown')
            if (dropdownButton) {
                dropdownButton.classList.toggle('dropdown--active')
            } else {
                dropdownHeadingButtons.forEach(x => x.classList.remove('dropdown--active'))
            }
        })

        const urlParams = getUrlParams()
        const categoryId = urlParams.categoryId
        const topicId = urlParams.topicId

        let fetchAndLoadFlag = false
        if (categoryId !== null) 
        {
            elm.dataset.currentCategoryId = categoryId;

            fetchAndLoadFlag = true

            const categoryLabel = elm.querySelector('[data-category-label]');
            const activeLabel = elm.querySelector('[data-category-id="' + categoryId + '"]');

            if (activeLabel) {
                categoryLabel.innerHTML = activeLabel.innerHTML
            }
        } 

        if (topicId !== null) 
        {
            elm.dataset.currentTopicId = topicId;
            
            fetchAndLoadFlag = true

            const topicLabel = elm.querySelector('[data-topic-label]');
            const activeLabel = elm.querySelector('[data-topic-id="' + topicId + '"]');
            
            if (activeLabel) {
                topicLabel.innerHTML = activeLabel.innerHTML
            }
            
        }

        // if (fetchAndLoadFlag) {
        //     FetchAndLoad(0)
        // }

        function FetchAndLoad(page) {
            // console.log(page)

            elm.dataset.page = page;
            const url = `/umbraco/surface/${elm.dataset.fetchApi}/${elm.dataset.fetchMethod}?categoryId=${elm.dataset.currentCategoryId}&topicId=${elm.dataset.currentTopicId}&Page=${page}&Universe=${elm.dataset.universe}&culture=${elm.dataset.culture}`;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(json => {
                    if (page == 1) {
                        container.innerHTML = json.html.Result;
                    } else {
                        container.innerHTML += json.html.Result;
                    }
                    loadMoreButton.classList.toggle('d-none', parseInt(json.totalPages) <= parseInt(json.currentPage));
                });
        }

        function setFilter(filterType, filterLabel, filterId) {
            const pageNr = 1
            
            if (filterType === "category") {
                catLabel.innerHTML = filterLabel;
                elm.dataset.currentCategoryId = filterId;
                setUrlParams("categoryId", filterId)
            }
            if (filterType === "topic") {
                topLabel.innerHTML = filterLabel;
                elm.dataset.currentTopicId = filterId;
                setUrlParams("topicId", filterId)
            }
            
            FetchAndLoad(pageNr)
        }

        function loadMore(pageNr) {
            FetchAndLoad(pageNr);
            setUrlParams("p", pageNr);
        }

        function setUrlParams(key, value) {
            const currentUrlParams = getUrlParams()
            currentUrlParams[key] = value

            const url = new URL(window.location.origin + window.location.pathname)

            Object.keys(currentUrlParams).forEach(label => {
                url.searchParams.set(label, currentUrlParams[label]);
            });
            
            window.history.pushState({}, '', url.href)
        }

        function getUrlParams() {
            const url_string = window.location.href
            const url = new URL(url_string);

            const searchParams = {}

            const categoryId = url.searchParams.get("categoryId");
            if (categoryId !== null && categoryId !== "") {
                searchParams["categoryId"] = categoryId
            }
            
            const topicId = url.searchParams.get("topicId");
            if (topicId !== null && topicId !== "") {
                searchParams["topicId"] = topicId
            }
            
            return searchParams
        }
    }
}
